import React, { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { faFileAlt, faInfo, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"

import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_USERSETING_PARAMS, ENUM_USERSETING_SETVALUE, FixHeight, FixMobileHeight, FixScreenHeight, GetLoginCredentialDb, getModValue, linksUrl } from "../constants/enum.js"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  MasterGrid,
  NextUITable,

} from "../components/index.js"
import { useFetchWithBody, usePost, usePostLogin, usePostMutateWithSuccess } from "../api/reactQueryCustomHooks.jsx"
import { resetCompCode, setAppType, setCompCode, setCompInfo, setCurrencyType, setReload, setSalePerson } from "../state/companySlice.jsx"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, TOP_ACTION_BTN_TYPE } from "../components/NextUITable.jsx"
import { addToast, Button, Card, CardBody } from "@heroui/react"
import { setLogout } from "../state/authSlice.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { isMobile } from "react-device-detect"
import { setDetailParams, setNewEntryMode } from "../state/orderSlice.jsx"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { format, toDate } from "date-fns"
import { Box, Typography } from "@mui/material"


const Companies = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { yearId, compCode, compName } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const [compData, setCompData] = useState([])
  const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
  const [orderDate, setOrderDate] = useState({
    fromDate: frDate(new Date()),
    toDate: frDate(new Date())
  });
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB");
  };
  const { data: ordData = [], mutate: filterOrder } = usePost({
    url: apiRoute.saleOrder.getOrder,
    queryKey: "getreportOrderdata"

  })
  const { mutate: funGetUserCompMap } = usePostMutateWithSuccess({
    url: apiRoute.userCompMaping.getUserMaping,
    queryKey: "getUsermaping",

  })

  // console.log(ordData)
  //console.log(userCompMapData)
  const {
    isPending,
    isError,
    data = [],
    mutate: funSetYearId
  } = usePost({
    url: apiRoute.setAcYearId,
    queryKey: "Company",
    onSuccessTasks: (data) => {
      const mainCompData = data

      if (mainCompData && mainCompData.length > 0) {

        funGetUserCompMap({
          data: {
            userid: user.username,
          },
          onSuccess: (data) => {
            const userData = data

            if (userData && userData.length > 0) {
              const selComp = userData.map(ele => String(ele.COMPCODE));
              let filterData = mainCompData.filter((ele) => selComp.includes(String(ele.COMPCODE)))

              setCompData(filterData[0])
              setcomInfo([filterData[0]])
              fun_setUseBroMap(filterData[0])

            }
            else {

              setCompData(mainCompData[0])
              setcomInfo([mainCompData[0]])
              fun_setUseBroMap(mainCompData[0])
            }
          }
        })
      }
      else
        setCompCode([])


    }



  })

  // const
  const setcomInfo = (selData) => {

    //const selData = compData
    // const salePerson = userCompMapData.filter(ele => ele.CompCode == selData[0].COMPCODE).map(item => item.SalePer_Name);
    // console.log(salePerson, "srtert", selData[0])
    dispatch(setCompCode({ compCode: [selData[0].COMPCODE], compName: [selData[0].COMPNAME] }))
    dispatch(setCompInfo({
      yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
      state: selData[0]?.STATE, groupCode: selData[0].CGCODE
      , address: selData[0]?.COMP_ADDRESS
      , panNo: selData[0]?.IT_NO
      , objComp: selData
      , gstNo: selData[0]?.Gst_No
      //, salePerson: salePerson
      //,objYear:[]]
    }))

  }


  // const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
  //   url: apiRoute.modSetting.getModSetting,
  //   queryKey: "fetchModSettingCurrency",
  //   inputData: {
  //     mod_name: ENUM_MOD_NAME.GeneralSettings
  //   }
  // })
  const fun_setUseBroMap = (selData) => {

    funGetUserBroMap({
      data: {
        userid: user.username,
        compcode: selData.COMPCODE
      },
      onSuccess: (data) => {

        if (data && data.length > 0)
          dispatch(setSalePerson(data))
        else {
          if (!toast.isActive("toastsmap")) {
            toast.error("Sale Person Maping Not Found  !", {
              "position": "top-center",
              // className: "toast-error"
              toastId: "toastsmap",
              onClose: () => {
                dispatch(setLogout())
                dispatch(resetCompCode())
                navigate(linksUrl.login)
              }
            })

          }
        }
      }
    })
  }

  const { data: salePersonData = [], mutate: funGetUserBroMap } = usePostMutateWithSuccess({
    url: apiRoute.userCompMaping.getUserBrokerMaping,
    queryKey: "getUsermaping",

  })

  // useEffect(() => {
  //   let CurrencyType = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting)
  //   dispatch(setCurrencyType(CurrencyType ?? ""))
  // }, [modSetting])
  console.log(compCode, "df")
  const funLoadData = (fdate, tdate) => {
    filterOrder({
      data: {
        comp_code: compCode.join(","),
        pac_id: null,
        bill_type: 'S',
        uid: user.isadmin == 1 ? null : user.username,
        fdate: fdate,
        tdate: tdate
      }
    })
  }
  useEffect(() => {
    if (compCode != null && compCode != "") {
      funLoadData(orderDate?.fromDate, orderDate?.toDate)
    }
  }, [compCode])
  useEffect(() => {
    funSetYearId({
      data: {
        ac_year: yearId,
        comp_code: ''
      }
    })

  }, [])

  const handleNewOrder = () => {
    dispatch(setNewEntryMode(true));
    dispatch(setDetailParams([]));
    navigate(linksUrl.salesOrder.createEntry);
  }

  const INITIAL_VISIBLE_COLUMNS = ["Ord_No", "Ord_Date", "Party", "Ord_Qty", "Amount"]

  const columns = [
    { header: "Ord No.", accessor: "Ord_No", type: "text", filterable: true, sortable: true, align: "center" },
    { header: "Date", accessor: "Ord_Date", type: "date", filterable: true, sortable: true, align: "center" },
    { header: "Party", accessor: "Party", type: "text", filterable: true, sortable: true },
    { header: "Qty", accessor: "Ord_Qty", type: "number", filterable: true, sortable: true, align: "right" },
    { header: "Amount", accessor: "Amount", type: "number", filterable: true, sortable: true, align: "right" },
    // { name: "Ord No.", uid: "Ord_No", sortable: true, align: COLUMN_ALIGN_TYPE.left },
    // { name: "Date", uid: "Ord_Date", sortable: true, align: COLUMN_ALIGN_TYPE.left, type: COLUMN_TYPE.date },
    // { name: "Party", uid: "Party", sortable: true, align: COLUMN_ALIGN_TYPE.left },
    // { name: "Qty", uid: "Ord_Qty", sortable: true, align: COLUMN_ALIGN_TYPE.left, type: COLUMN_TYPE.number },
    // { name: "Amount", uid: "Amount", sortable: true, align: COLUMN_ALIGN_TYPE.left, type: COLUMN_TYPE.number },
  ]

  // const topActionBtn = [
  //   {
  //     label: "Connect",
  //     icon: <FontAwesomeIcon icon={faPlus} />,
  //     isShowOnSelection: true,
  //     type: TOP_ACTION_BTN_TYPE.link,
  //     onClick: ({ selectedKeys }) => {
  //       let selectedCompCode = []
  //       let selectedCompName = []
  //       if (selectedKeys !== "all") {
  //         selectedKeys.forEach((value) => {
  //           selectedCompCode.push(value)
  //           //get selected compname
  //           let filterData = compData.filter((ele) => ele.COMPCODE == value)
  //           if (filterData && filterData.length > 0) selectedCompName.push(filterData[0].COMPNAME)
  //         })
  //       } else {
  //         compData.map((item) => selectedCompCode.push(item.COMPCODE))
  //       }
  //       toast.success("Conntected", {
  //         position: "top-center",
  //         autoClose: 1000,
  //       })

  //       //get selected company name 
  //       const intSelCompCode = selectedCompCode.map(value => parseInt(value, 10));
  //       const selData = compData.filter((ele) => intSelCompCode.includes(ele.COMPCODE))
  //       console.log(selData)
  //       dispatch(setCompCode({ compCode: selectedCompCode, compName: selectedCompName }))
  //       dispatch(setCompInfo({
  //         yearId: selData[0]?.YEAR_ID, startDate: selData[0]?.SDATE, endDate: selData[0]?.EDATE,
  //         state: selData[0]?.STATE, groupCode: selData[0].CGCODE
  //         , address: selData[0]?.COMP_ADDRESS
  //         , panNo: selData[0]?.IT_NO
  //         , objComp: selData
  //         ,gstNo:selData[0]?.Gst_No
  //         //,objYear:[]]
  //       }))

  //       let startup_page = linksUrl.dashboard

  //       navigate(startup_page)
  //     },
  //   },
  // ]

  if (isPending) {
    return <LoadingCard />
  }
  const handleOnclick = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  const handleFilter = () => {
    funLoadData(orderDate?.fromDate, orderDate?.toDate)
  }
  const handleClear = () => {
    setOrderDate({ fromDate: frDate(new Date()), toDate: frDate(new Date()) })
    funLoadData(frDate(new Date()), frDate(new Date()))
  }
  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>

      <MainContainer pageName={"Home"}
        breadcrumbs={[]}>
        <Card>
          <CardBody className=""
            style={{ height: isMobile ? FixMobileHeight : FixScreenHeight }}
          >
            {/* <MyComponent items={items}  /> */}
            <div className=" flex justify-end">
              <Button size="md" radius="sm" color="success" variant={"flat"} onPress={handleNewOrder}
                className=" h-8 border-0 text-sm uppercase  font-semibold bg-gradient-to-t from-lime-700 to-lime-500  text-white"
                startContent={<FontAwesomeIcon className="text-md" icon={faFileAlt} />}>New Order</Button>
            </div>


            <div className="bg-white p-2 h-screen">

              <div className="p-2 shadow mb-0">
                {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                  <div className="flex no-wrap gap-5 mt-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={"From Date"}
                        views={["day", "month", "year"]}
                        size="small"
                        format="DD/MM/YYYY"
                        value={
                          orderDate.fromDate
                            ? dayjs(orderDate.fromDate)
                            : orderDate.fromDate
                        }
                        onChange={(newValue) => {
                          setOrderDate((prev) => {
                            return {
                              ...prev,
                              fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                dayjs(newValue).format("YYYY-MM-DD") : null,
                            };
                          });
                        }}
                        slotProps={{
                          textField: { size: "small", },
                        }}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={"To  Date"}
                        views={["day", "month", "year"]}
                        format="DD/MM/YYYY"
                        size="small"
                        value={
                          orderDate.toDate
                            ? dayjs(orderDate.toDate)
                            : orderDate.toDate
                        }
                        onChange={(newValue) => {
                          setOrderDate((prev) => {
                            return {
                              ...prev,
                              toDate: newValue != '' && newValue != 'Invalid Date' ?
                                dayjs(newValue).format("YYYY-MM-DD") : null,
                            };
                          });
                        }}
                        slotProps={{
                          textField: { size: "small", },
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="flex no-wrap gap-5 justify-center items-center">
                    <Button onPress={handleFilter} className="font-semibold uppercase bg-red-700 text-white" variant="solid" color="primary" size="sm" >Get Order</Button>
                    <Button onPress={handleClear} className="font-semibold uppercase bg-gray-600" variant="solid" color="danger" size="sm" >Reset Date</Button>
                  </div>
                </div>
              </div>

              <div className="pt-5">
                {ordData && ordData.length > 0 ?

                  <MasterGrid
                    columns={columns}
                    data={ordData}
                    className={""}
                    showPaging={true}
                    pageSize={20}
                    expandableRow={false}
                    headClass={"bg-slate-700 border-1 border-slate-300 text-white uppercase text-xs"}
                    filterClass={"bg-slate-100 border-1 border-slate-300"}
                    style={{ border: "1px solid red" }}
                    exportHeader={{
                      companyName: compName.join(","),
                      reportName: `Date Wise Order Detail From ${formatDate(orderDate.fromDate)} To ${formatDate(orderDate.toDate)}`,

                    }}
                  ></MasterGrid> : <Box sx={{
                    p: 4,
                    textAlign: 'center',
                    border: `1px dashed gray`,
                    borderRadius: 2,
                    backgroundColor: 'background.default'

                  }}>
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2
                    }}>
                      <FontAwesomeIcon icon={faInfo} />
                      {/* <DescriptionOutlined sx={{
                                  fontSize: 48,
                                  color: 'text.disabled'
                                }} /> */}
                      <Typography variant="h6" color="text.secondary">
                        No  data available
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        Apply filters above to generate a report
                      </Typography>
                    </Box>
                  </Box>}                {/* <NextUITable
                  INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                  data={ordData}
                  columns={columns}
                  exportColumns={columns}
                  //topActionBtn={topActionBtn}
                   downloadDataFooter={downloadDataFooter}
                  downloadFileName="Order List"
                  showAdvanceFilter={false}
                  id="Ord_No"
                  rowSelection={false}

                /> */}
              </div>
            </div>
          </CardBody>
        </Card>
        {/* {isError ? <div className="bg-yellow-200 px-6 py-4 my-4 text-amber-700 rounded-md text-md flex gap-4  items-center mx-auto max-w-lg">Something went wrong !
          <Button onPress={handleOnclick()} variant="light" style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700" >Click here to Reconnect</Button> </div> :
          <NextUITable
            INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
            data={compData}
            columns={columns}
            exportColumns={columns}
            topActionBtn={topActionBtn}
            downloadFileName="Company"
            showAdvanceFilter={false}
            id="COMPCODE"
            rowSelection={true}

          />
        } */}
      </MainContainer>

    </div>
  )
}

export default Companies
